import React from "react";
import Container from "../../../../components/Layout/Container";
import {
  QueryClient,
  QueryClientProvider,
  useQuery,
  useMutation,
} from "react-query";
import { DEFAULT_PER_PAGE } from "../../../../helpers/default";
import ContentBlock from "../../../../components/Layout/ContentBlock";
import FilterMenu from "../../../../components/Layout/FilterMenu";
import Axios from "axios";
import {
  ButtonSecondary,
  Label,
  Pagination,
  SelectInput,
  TextInput,
} from "../../../../components/globals";
import TableFilterBox from "../../../../components/common/TableFilterBox";
import {
  ButtonDelete,
  ButtonSmall,
  ButtonEditRow,
} from "../../../../components/common/Buttons";
import { IconSearch, IconHistory } from "../../../../components/Layout/Icons";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../../../helpers/AsyncMessage";
import { Checkbox, Tabs, Modal } from "antd";
import { useModal } from "../../../../hooks";
import { AiOutlineLeft } from "react-icons/ai";
import { FaChevronDown } from "react-icons/fa";
import { getDateFormat } from "../../../../helpers/Utils";
import { InputSwitchComponent } from "../../../../components/globals";
import SwitchComp from "../../../../components/common/SwitchComp";
import { IconPromotionPopups } from "../../../../components/Layout/Icons";
import { SelectForm } from "../../../../components/common/Buttons";
import RangePickerComp from "../../../../components/common/RangePickerComp";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import ImageWithPreviewModal from "./modals/ImageWithPreviewModal";
import axios from "axios";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import MarketingFeatureTabUi from "./MarketingFeatureTabUi";
import ModalNewPromotionPopups from "./modals/ModalNewPromotionPopups";
import ContentValidation from "../../../../components/common/ContentValidation";
import { convertToTreeData } from "../../../../helpers/ConvertToTreeData";
import Treeselect from "../../../../components/common/Treeselect";

dayjs.extend(isBetween);

const { confirm } = Modal;

const PromotionPopups = ({ tabId, setTabId }) => {
  const [page, setPage] = React.useState(1);
  const [totals, setTotals] = React.useState(0);
  const [perPage, setPerPage] = React.useState(DEFAULT_PER_PAGE);
  const [filterTitle, setFilterTitle] = React.useState("");
  const [filterDatePeriod, setFilterDatePeriod] = React.useState([]);
  const [filterCustomEvent, setFilterCustomEvent] = React.useState("");
  const [filterShop, setFilterShop] = React.useState("");
  const [filterCategory, setFilterCategory] = React.useState([]);
  const [filterStatus, setFilterStatus] = React.useState("");

  const { modalOpt, setModalOpt, closeModal } = useModal();
  const fetchOrderShops = async () => {
    const response = await axios.get("/api/v1/order_shops");
    return response.data;
  };

  const { data: orderShops } = useQuery("orderShops", fetchOrderShops);
  const ALLOWED_SHOPS = ["BB LT", "BB LV", "BB EE", "BB FI", "TR LT"];
  const allShops = orderShops?.shops || [];
  const shops = allShops.filter(s => ALLOWED_SHOPS.includes(s.label));

  const fetchCategories = async () => {
    const response = await axios.get("/api/v1/categories/simple_list?page=1&per_page=9999999");
    return response.data;
  };

  const {
    data: categories,
  } = useQuery("categories", fetchCategories);

  const bigBoxCategory = categories?.find(
    (category) => category.name === "BIGBOX"
  );

  const fetchBanners = async () => {
    let url = `/api/v1/banners?page=${page}&per_page=${perPage}&q[banner_place_eq]=promotion_popups`;
    if (filterTitle) {
      url += `&q[title_i_cont]=${filterTitle}`;
    }
    if (filterCustomEvent) {
      url += `&q[custom_event_i_cont]=${filterCustomEvent}`;
    }
    if (filterDatePeriod?.length) {
      url += `&q[valid_to_gteq]=${filterDatePeriod[0]}&q[valid_from_lteq]=${filterDatePeriod[1]}`;
    }
    if (filterShop) {
      url += `&q[banner_shops_order_shop_id_eq]=${filterShop}`;
    }
    if (Array.isArray(filterCategory) && filterCategory.length) {
      url += `&q[banner_shops_categories_raw_cont_any][]=${filterCategory
        .map((id) => "-%20" + id + "%0A")
        .join("&q[banner_shops_categories_raw_cont_any][]=")}`;
    }
    if (filterStatus) {
      url += `&q[banner_shops_active_true]=${filterStatus}`;
    }
    const response = await axios.get(url);
    return response.data;
  };

  const {
    data: banners,
    isLoading: bannersLoading,
    error: bannersError,
    refetch: refetchBanners,
  } = useQuery("banners", fetchBanners);

  const deleteBannerMutation = useMutation(
    (id) => axios.delete(`/api/v1/banners/${id}`),
    {
      onSuccess: () => {
        antdAsyncMessageSuccess({
          text: "Successfully deleted",
          key: "delete_banner",
        });
        refetchBanners();
      },
      onError: () => {
        antdAsyncMessageError({
          text: "Error occurred",
          key: "delete_banner",
        });
      },
    }
  );

  const switchStatusMutation = useMutation({
    mutationFn: (value) => {
      console.log(value);
      const formData = new FormData();
      formData.append("banner[banner_shops_attributes][0][id]", value.shopId);
      formData.append(
        "banner[banner_shops_attributes][0][active]",
        value.active
      );

      return axios.put(`/api/v1/banners/${value.id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: () => {
      antdAsyncMessageSuccess({
        text: "Successfully updated",
        key: "update_banner",
      });
      refetchBanners();
    },
    onError: () => {
      antdAsyncMessageError({
        text: "Error occurred",
        key: "update_banner_error",
      });
    },
  });

  const handleFilterChange = () => {
    refetchBanners();
  };

  const handleFilterClear = () => {
    setFilterCustomEvent("");
    setFilterTitle("");
    setFilterCategory([]);
    setFilterShop("");
    setFilterStatus("");
    setFilterDatePeriod([]);
  };

  React.useEffect(() => {
    if (banners?.totals) {
      setTotals(banners?.totals);
    }
  }, [banners]);

  React.useEffect(() => {
    refetchBanners();
  }, [page, perPage]);

  React.useEffect(() => {
    refetchBanners();
  }, [modalOpt]);

  return (
    <>
      <ContentBlock>
        <FilterMenu
          length={banners?.totals}
          text2={`promotion popups`}
          iconComponent={<IconPromotionPopups />}
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
          totals={banners?.data?.totals}
        />
      </ContentBlock>
      <div className="col-12">
        <MarketingFeatureTabUi tabId={tabId} setTabId={setTabId} />
      </div>
      <ContentBlock containerClass="py-1">
        <TableFilterBox
          filter={true}
          onFilter={() => {
            handleFilterChange();
          }}
          add={false}
          clearFilter={() => handleFilterClear()}
          button1={
            <>
              <div className="float-left ml-2" style={{ width: 104 }}>
                <ButtonSecondary
                  onClick={() => setModalOpt("new_promotion_popups", 0)}
                >
                  New popup
                </ButtonSecondary>
              </div>
            </>
          }
        >
          <div className="d-flex justify-content-between flex-1 flex-wrap">
            <div className="d-flex flex-wrap">
              <>
                <div className="px-1">
                  <TextInput
                    text="Title"
                    name="Title"
                    style={{ width: 165 }}
                    value={filterTitle}
                    onChange={(val) => {
                      setFilterTitle(val.target.value);
                    }}
                  />
                </div>
                <div className="px-1" style={{ width: 250 }}>
                  <Label className="text-sm-label">Category</Label>
                  <Treeselect
                    options={convertToTreeData(categories) || []}
                    value={filterCategory}
                    onChange={(values) => {
                      console.log(values);
                      setFilterCategory(values)
                    }}
                    placeholder="Select categories..."
                    multiSelect={true}
                    searchable={true}
                    style={{ minWidth: 165 }}
                    dropdownWidth="500px"
                  />
                </div>
                <div className="px-1">
                  <RangePickerComp
                    style={{ width: "250px" }}
                    label="Date period"
                    showTime={{ format: "HH:mm" }}
                    placeholder={["Start time", "End time"]}
                    value={
                      filterDatePeriod
                        ? [
                          getDateFormat(filterDatePeriod[0]),
                          getDateFormat(filterDatePeriod[1]),
                        ]
                        : ["", ""]
                    }
                    onChange={(_, value) => {
                      setFilterDatePeriod(value);
                    }}
                    disabledDate={() => false}
                  />
                </div>
                <div className="px-1">
                  <SelectForm
                    placeholder="Shop"
                    options={[{ value: null, label: " " }, ...shops]}
                    selector="product_active"
                    style={{ width: 165 }}
                    value={filterShop}
                    onChange={(product_active) => setFilterShop(product_active)}
                  />
                </div>

              </>
            </div>
          </div>
        </TableFilterBox>
        <div>
          <div className="table-responsive" style={{ overflow: "hidden" }}>
            <ContentValidation
              loader={bannersLoading}
              array={banners?.data}
              error={bannersError}
            >
              <table className="table mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">Title</th>
                    <th className="text-black">Type</th>
                    <th className="text-black">Visible in</th>
                    <th className="text-black">Valide period</th>
                    <th className="text-black">Shop</th>
                    <th className="text-black">Status</th>
                    <th className="text-black">Content</th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {banners?.data?.map?.((item) => (
                    <tr className="align-middle tableColumn" key={item.id}>
                      <td className="align-middle">{item?.title}</td>
                      <td className="align-middle">
                        {item?.background_type === "text" ? "Product" : "Image"}
                      </td>
                      <td className="align-middle capitalize-first-letter">
                        {item?.popup_in}
                      </td>
                      <td className="align-middle">
                        <div className="d-flex flex-row align-items-center">
                          <div
                            style={{
                              width: 10,
                              height: 10,
                              marginRight: 5,
                              borderRadius: 100,
                              backgroundColor: dayjs().isBetween(
                                dayjs(item?.valid_from),
                                dayjs(item?.valid_to)
                              )
                                ? "#28A745"
                                : "#C94747",
                            }}
                          />
                          {`${dayjs(item?.valid_from).format(
                            "YYYY-MM-DD HH:mm"
                          )} - ${dayjs(item?.valid_to).format(
                            "YYYY-MM-DD HH:mm"
                          )}`}
                        </div>
                      </td>
                      <td className="align-middle">
                        {item?.banner_shops?.map?.((shop, index) => (
                          <div
                            key={"shop.order_shop.title" + index}
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              backgroundColor: "#F5F5F5",
                              height: 30,
                              padding: 5,
                              marginBottom: 5,
                              width: "fit-content",
                            }}
                          >
                            <p style={{ marginBottom: 0, marginTop: 0 }}>
                              {shop.order_shop.title}
                            </p>
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        {item?.banner_shops?.map?.((shop, index) => (
                          <div
                            key={"shop.active" + index}
                            className="d-flex align-items-center switch-container"
                          >
                            <SwitchComp
                              className=""
                              checked={shop.active}
                              onChange={() =>
                                switchStatusMutation.mutate({
                                  id: item?.id,
                                  shopId: shop?.id,
                                  active: !shop.active,
                                })
                              }
                            />
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        {item?.banner_shops?.map((shop, index) => (
                          <div
                            className="align-items-center d-flex flex-row"
                            key={index}
                          >
                            {item?.background_type === "text" ? (
                              <div
                                key={"shop-products" + index}
                                className="d-flex justify-content-center align-items-center grey-tabblet"
                              >
                                <p style={{ marginBottom: 0, marginTop: 0 }}>
                                  {shop?.products?.length === 1
                                    ? shop?.products?.[0]?.title
                                    : `${shop?.products?.length} products batch`}
                                </p>
                              </div>
                            ) : (
                              <ImageWithPreviewModal
                                key={"shop-desktop_image" + index}
                                asset={{
                                  url:
                                    shop?.desktop_image ||
                                    "https://via.placeholder.com/150",
                                }}
                                created_at={item?.created_at}
                                id={item?.id}
                                height={30}
                              />
                            )}
                            <p
                              style={{
                                marginLeft: 5,
                                marginRight: 5,
                                marginBottom: 0,
                                margintTop: 0,
                              }}
                            >
                              In
                            </p>
                            {item?.popup_in === "product" && (
                              <div
                                key={"shop-products-page" + index}
                                className="d-flex justify-content-center align-items-center grey-tabblet"
                              >
                                <p style={{ marginBottom: 0, marginTop: 0 }}>
                                  {shop?.products_page?.length === 1
                                    ? shop?.products_page?.[0]?.title
                                    : `${shop?.products_page?.length} products batch`}
                                </p>
                              </div>
                            )}
                            {item?.popup_in === "category" && (
                              <div
                                key={"shop-categories" + index}
                                className="d-flex justify-content-center align-items-center grey-tabblet"
                              >
                                <p style={{ marginBottom: 0, marginTop: 0 }}>
                                  {shop?.categories?.length === 1
                                    ? shop?.categories?.[0]?.name
                                    : `${shop?.categories?.length} categories batch`}
                                </p>
                              </div>
                            )}
                            {item?.popup_in === "url" && (
                              <div
                                key={"shop-url" + index}
                                className="d-flex justify-content-center align-items-center grey-tabblet"
                              >
                                <p style={{ marginBottom: 0, marginTop: 0 }}>
                                  {shop?.destination_url?.length === 1
                                    ? shop?.destination_url?.[0]
                                    : `${shop?.destination_url?.length} URL’s batch`}
                                </p>
                              </div>
                            )}
                          </div>
                        ))}
                      </td>
                      <td className="align-middle">
                        <div
                          className="d-flex justify-content-end"
                          style={{ gap: 5 }}
                        >
                          <ButtonEditRow
                            className="d-flex justify-content-center align-items-center"
                            onClick={() =>
                              setModalOpt("edit_promotion_popups", item?.id)
                            }
                          />
                          <ButtonDelete
                            className="d-flex justify-content-center align-items-center"
                            onDelete={() =>
                              confirm({
                                title: "Are you sure?",
                                icon: (
                                  <ExclamationCircleOutlined className="text-primary" />
                                ),
                                content:
                                  "You will not be able to undo this action",
                                onOk() {
                                  deleteBannerMutation.mutate(item.id);
                                },
                                onCancel() {
                                  console.log("Cancel");
                                },
                              })
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </ContentValidation>
            <Pagination
              setPagination={setPage}
              page={page}
              totals={totals}
              pageCount={perPage}
            />
          </div>
        </div>
        {modalOpt.type === "new_promotion_popups" && (
          <ModalNewPromotionPopups
            onClose={closeModal}
            modalOpt={modalOpt}
            orderShops={shops}
            bigBoxCategory={convertToTreeData(categories)}
          />
        )}
        {modalOpt.type === "edit_promotion_popups" && (
          <ModalNewPromotionPopups
            onClose={closeModal}
            modalOpt={modalOpt}
            orderShops={shops}
            bigBoxCategory={convertToTreeData(categories)}
            bannerData={banners?.data}
          />
        )}
      </ContentBlock>
    </>
  );
};

export default PromotionPopups;
